import {Component, OnInit, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {ColaboradorHorario} from '@modelo/catalogo/ColaboradorHorario.model';

@Component(
    {
        selector: 'colaborador_horario',
        templateUrl: './colaborador_horario.template.html',
        styleUrls: ['../colaborador.component.scss']
    })

export class ColaboradorHorarioComponent implements OnInit {
    @Input() id!: number;
    @Input() disabled!: boolean;

    public entidad: ColaboradorHorario;

    SelCiclo: any[];
    SelSemestre: any[];

    public abierto!: boolean;
    public animacion!: string;
    public errorActivo!: boolean;

    dataTable!: Array<any>;
    dataTable2!: Array<any>;
    
    cicloActual!:number;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new ColaboradorHorario();

        this.SelCiclo = [];
        this.SelSemestre = [];
    }

    ngOnInit() {
        this.setCiclo();
        this.setSemestre();

        this.Buscar();
    }


    setCiclo() {
        this.appService.Get("catalogo/ciclo").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCiclo = res.data
                let actual = this.SelCiclo.find(x=>x.actual);
                if(actual){
                    this.cicloActual = actual.cicloid;
                    this.entidad.cicloid = this.cicloActual;
                }
            }
        });
    }
    setSemestre() {
        this.appService.Get("catalogo/semestre").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelSemestre = res.data
            }
        });
    }

    Editar(e: ColaboradorHorario) {
        this.entidad = new ColaboradorHorario(e);
        this.Modal();
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
    }

    CerrarModal() {
        this.entidad = new ColaboradorHorario({cicloid : this.cicloActual});
        this.animacion = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar(): Promise<any> {
        return new Promise((resolve, reject) => {
            let respuesta = this.Validar();
            if (respuesta != true) {
                return this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
            }


            let data = new ColaboradorHorario(this.entidad);
            this.appService.Post("configuracionrh/colaborador/horario/" + this.id, data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.CerrarModal()
                    this.Buscar();
                }
            })
        })
    }

    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.cicloid) {
            return "Ingrese un ciclo";
        }

        if (this.entidad.especial) {
            if (!this.entidad.horarioespecial.trim()) {
                return "Ingrese un horario especial";
            }
        } else {
            //Lunes
            if (this.entidad.lunessalida.trim()) {
                if (!this.entidad.lunesentrada.trim()) {
                    return "Complete el rango de horario del lunes";
                }
            }
            if (this.entidad.lunesentrada.trim()) {
                if (!this.entidad.lunessalida.trim()) {
                    return "Complete el rango de horario del lunes";
                }
            }

            //Martes
            if (this.entidad.martessalida.trim()) {
                if (!this.entidad.martesentrada.trim()) {
                    return "Complete el rango de horario del martes";
                }
            }
            if (this.entidad.martesentrada.trim()) {
                if (!this.entidad.martessalida.trim()) {
                    return "Complete el rango de horario del martes";
                }
            }

            //Miercoles
            if (this.entidad.miercolessalida.trim()) {
                if (!this.entidad.miercolesentrada.trim()) {
                    return "Complete el rango de horario del miercoles";
                }
            }
            if (this.entidad.miercolesentrada.trim()) {
                if (!this.entidad.miercolessalida.trim()) {
                    return "Complete el rango de horario del miercoles";
                }
            }

            //Jueves
            if (this.entidad.juevessalida.trim()) {
                if (!this.entidad.juevesentrada.trim()) {
                    return "Complete el rango de horario del jueves";
                }
            }
            if (this.entidad.juevesentrada.trim()) {
                if (!this.entidad.juevessalida.trim()) {
                    return "Complete el rango de horario del jueves";
                }
            }

            //Viernes
            if (this.entidad.viernessalida.trim()) {
                if (!this.entidad.viernesentrada.trim()) {
                    return "Complete el rango de horario del viernes";
                }
            }
            if (this.entidad.viernesentrada.trim()) {
                if (!this.entidad.viernessalida.trim()) {
                    return "Complete el rango de horario del viernes";
                }
            }
            
            //Sabado
            if (this.entidad.sabadosalida.trim()) {
                if (!this.entidad.sabadoentrada.trim()) {
                    return "Complete el rango de horario del sabado";
                }
            }
            if (this.entidad.sabadoentrada.trim()) {
                if (!this.entidad.sabadosalida.trim()) {
                    return "Complete el rango de horario del sabado";
                }
            }
            
            //Sabado
            if (this.entidad.domingosalida.trim()) {
                if (!this.entidad.domingoentrada.trim()) {
                    return "Complete el rango de horario del domingo";
                }
            }
            if (this.entidad.domingoentrada.trim()) {
                if (!this.entidad.domingosalida.trim()) {
                    return "Complete el rango de horario del domingo";
                }
            }
        }

        return true;
    }

    Buscar() {
        this.appService.Get("configuracionrh/colaborador/horario/" + this.id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.dataTable = res.data.horario;
                this.dataTable2 = res.data.horarioespecial;
            }
        })
    }

    Eliminar(e: ColaboradorHorario) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracionrh/colaborador/horario/" + e.colaboradorhorarioid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.Buscar();
                    }
                })
            }
        })
    }

}
